const ARTHENE_CODES = [
    "TELIA_MOBIL_10GB_02",
    "TELIA_MOBIL_10GB_2025",
    "TELIA_MOBIL_10GB_2026",
    "TELIA_X_START",
    "TELIA_X_START_2025",
    "TELIA_X_START_2026",
    "TELIA_X_BASIC",
    "TELIA_X_BASIC_2025",
    "TELIA_X_BASIC_2026",
    "TELIA_X_BASIC_2025_2",
    "TELIA_X_MAX",
    "TELIA_X_MAX_2025",
    "TELIA_X_MAX_2026",
    "TELIA_X_MAX_PLUS",
    "TELIA_X_MAX_PLUS_2025",
    "TELIA_X_MAX_PLUS_2026",
    "TELIA_JUNIOR_01GB",
    "TELIA_JUNIOR_03GB",
] as const;

type AtheneCode = (typeof ARTHENE_CODES)[number];

const SUBSCRIPTION_CODES = [
    "TELIA_MOBIL_02GB",
    "TELIA_MOBIL_03GB",
    "TELIA_MOBIL_05GB",
    "TELIA_MOBIL_05GB_2025",
    "TELIA_MOBIL_05GB_2025_2",
    "TELIA_MOBIL_10GB_2025_2",
    "TELIA_X_BASIC_2025_2",
    "TELIA_X_BASIC_2025",
    "TELIA_X_BASIC_2026",
    "TELIA_MOBIL_X_UNG_2025_2",
    "TELIA_MOBIL_X_UNG_2026",
    "TELIA_MOBIL_06GB",
    "TELIA_MOBIL_08GB",
    "TELIA_MOBIL_10GB",
    "TELIA_MOBIL_10GB_UNG",
    "TELIA_MOBIL_15GB",
    "TELIA_MOBIL_15GB_02",
    "TELIA_MOBIL_20GB",
    "TELIA_MOBIL_X_MAX",
    "TELIA_MOBIL_X_NORMAL",
    "TELIA_MOBIL_X_RASK",
    "TELIA_MOBIL_X_UNG",
    "TELIA_MOBIL_X_RASK_VT",
    "SMART_BARN_S",
    "SMART_BARN_L",
    "SMART_BARN_XL",
    "TELIA_JUNIOR_KLOKKE_01GB",
    "TELIA_JUNIOR_01GB+PROMO_JR06_50",
    "TELIA_JUNIOR_03GB+PROMO_JR06_50",
    "TELIA_JUNIOR_KLOKKE_1GB",
    "TELIA_X_INTRO+PROMO_INTRO_02_199",
    "TELIA_X_INTRO_2026+PROMO_INTRO_02_199",
    "TELIA_JUNIOR_01GB+PROMO_JR06_50_2026",
    "TELIA_JUNIOR_10GB_2026+PROMO_JR06_50_2026",
] as const;

const NEW_SUBSCRIPTION_CODES = [
    "TELIA_MOBIL_05GB_2026",
    "TELIA_MOBIL_10GB_2026",
    "TELIA_MOBIL_10GB_UNG_2026",
    "TELIA_MOBIL_X_UNG_2026",
    "TELIA_X_BASIC_2026",
    "TELIA_X_MAX_2026",
    "TELIA_X_MAX_PLUS_2026",
    "TELIA_X_START_2026",
    "TELIA_JUNIOR_10GB_2026",
    "TELIA_MOBIL_X_RASK_VT_2026",
    "TELIA_MOBIL_01GB_2027",
    "TELIA_MOBIL_03GB_2027",
    "TELIA_MOBIL_15GB_2027",
    "TELIA_X_BASIC_2027",
    "TELIA_X_MAX_2027",
    "TELIA_X_MAX_PLUS_2027",
    "TELIA_X_START_2027",
] as const;

const CAMPAIGN_SUBSCRIPTION_CODES = ["TELIA_X_KAMPANJE_2026_2"] as const;

const ALL_SUBSCRIPTION_CODES = [
    ...SUBSCRIPTION_CODES,
    ...NEW_SUBSCRIPTION_CODES,
    ...CAMPAIGN_SUBSCRIPTION_CODES,
] as const;

type SubscriptionCode = (typeof ALL_SUBSCRIPTION_CODES)[number];

const B2B_SUBSCRIPTION_CODES = [
    "TELIA_PURPLE_01GB",
    "TELIA_PURPLE_02GB",
    "TELIA_PURPLE_06GB",
    "TELIA_PURPLE_15GB",
    "TELIA_PURPLE_20GB",
    "TELIA_PURPLE_50GB",
    "TELIA_PURPLE_FRI",
    "TELIA_PURPLE_VAR",
    "TELIA_PURPLE_X_MAX",
    "TELIA_PURPLE_X_NORMAL",
    "TELIA_PURPLE_X_RASK",
] as const;

type B2BSubscriptionCode = (typeof B2B_SUBSCRIPTION_CODES)[number];

const MBB_OFFERING_CODES = [
    "MBB4G_005GB_BIZ_2",
    "MBB4G_007GB_PRIV_2",
    "MBB4G_010GB_PRIV_3",
    "MBB4G_015GB_PRIV_2",
    "MBB4G_020GB_BIZ_2",
    "MBB4G_025GB_PRIV_3",
    "MBB4G_030GB_PRIV_2",
    "MBB4G_040GB_BIZ_2",
    "MBB4G_050GB_PRIV_2",
    "MBB4G_050GB_PRIV_3",
    "MBB4G_080GB_BIZ_2",
    "MBB4G_100GB_PRIV_2",
    "MBB4G_100GB_PRIV_3",
    "MBB4G_150GB_BIZ_2",
    "MBB4G_200GB_PRIV_2",
    "MBB4G_200GB_PRIV_3",
    "MBB4G_300GB_BIZ_2",
    "MBB4G_500GB_BIZ_2",
    "MBB4G_500GB_PRIV_3",
    "MBB_002GB_PRIV_4",
    "MBB_010GB_PRIV_4",
    "MBB_025GB_PRIV_4",
    "MBB_050GB_PRIV_4",
    "MBB_100GB_PRIV_4",
    "MBB_250GB_PRIV_4",
    "MBB_500GB_PRIV_4",
] as const;

export const OFFERING_CODES_TO_HALF_PRICE: SubscriptionType[] = [
    "TELIA_JUNIOR_01GB+PROMO_JR06_50_2026",
    "TELIA_JUNIOR_10GB_2026+PROMO_JR06_50_2026",
] as const;

type MBBOfferingCode = (typeof MBB_OFFERING_CODES)[number];

export const SERVICE_SUBSCRIPTION_CODES = [
    "TRYGG_B2C",
    "TRYGG_B2C_FAMILY",
    "TRYGG_B2C_INDIVIDUAL",
    "TRYGG_B2C_TEST",
    "TRYGG_B2C_FREE",
] as const;

type ServiceSubscriptionCode = (typeof SERVICE_SUBSCRIPTION_CODES)[number];

const DEPRECATED_SUBSCRIPTION_CODES = [
    "CONNECT_PREPAID",
    "KONTANT_KOMPLETT",
    "SMART_BARN_2",
    "SMART_BARN_L",
    "SMART_BARN_M",
    "SMART_BARN_S",
    "SMART_BASIC",
    "SMART_MINI_2",
    "SMART_MINI_3",
    "SMART_PLUSS",
    "SMART_SUPERX",
    "SMART_TOTAL",
    "SMART_TOTAL_2",
    "SMART_UNG_02",
    "SMART_UNG_08",
    "SMART_UNG_12",
    "SMART_UNG_L",
    "SMART_UNG_M",
] as const;

type DeprecatedSubscriptionCode = (typeof DEPRECATED_SUBSCRIPTION_CODES)[number];

const KEEP_EXISTING_CODES = ["keep_existing", "keepExisting", "existing-subscription-placeholder"] as const;
const KEEP_EXISTING_SUBSCRIPTION_TYPE = "KEEP";

type KeepExistingSubscriptionCode = (typeof KEEP_EXISTING_CODES)[number];
type KeepExistingSubscriptionType = typeof KEEP_EXISTING_SUBSCRIPTION_TYPE;

export type SubscriptionType =
    | SubscriptionCode
    | MBBOfferingCode
    | B2BSubscriptionCode
    | DeprecatedSubscriptionCode
    | KeepExistingSubscriptionCode
    | AtheneCode
    | ServiceSubscriptionCode
    | "";

type LeaseIcim = "TLF12PLEAS";
type LeaseIcimSummer = "TLF12PLEAS_SUMMER";
type LeaseMbbIcim = "HW12LEAS_2";
export const HW_BUNDLE_LEASE_CODE: LeaseIcim = "TLF12PLEAS";
export const MBB_BUNDLE_COMMITMENT_CODE: LeaseMbbIcim = "HW12LEAS_2";
export const BROADBAND_CODE_PREFIX = "MBB";

export const SIMDEAL_CAMPAIGN_CODE = "COM12LOUDSPEAKER2";
export type CampaignCode =
    | typeof SIMDEAL_CAMPAIGN_CODE
    | "COM12PURP10"
    | "COM12PURP15"
    | "COM12PURP20"
    | "COM12PURP25"
    | "COM12PURP30"
    | "COM12PURP20TME"
    | "COM12PSPOT"
    | "COM12PFAM"
    | "COM12KR3"
    | "HW12R20BTL"
    | "COM12LOUDSPEAKER2_SUMMER";

export type Icim = "REGULAR" | CampaignCode | LeaseIcim | LeaseIcimSummer | LeaseMbbIcim | KeepExistingSubscriptionType;
export type OfferingCode = `${SubscriptionType}.${Icim}` | "";

export const BLOCKED_SIM_ONLY_OFFERING_CODES: OfferingCode[] = ["TELIA_X_KAMPANJE_2026_2.REGULAR"];
